// src/pages/Contacto.js
import React from "react";

export default function Contacto() {
  return (
    <section>
      <h2 className="text-3xl font-bold mb-4">Contacto</h2>
      <p className="mb-4">Puedes contactarnos vía:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Teléfono:{" "}
          <a href="tel:+591591, Cochabamba" className="text-blue-600 underline">
            +591 123 45678
          </a>
        </li>
        <li>
          Correo:{" "}
          <a
            href="info@halcontiendasdedeporte.com."
            className="text-blue-600 underline"
          >
            ventas@tiendadeportiva.com
          </a>
        </li>
        <li>
          WhatsApp:{" "}
          <a
            href="https://wa.me/59112345678"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            Chat por WhatsApp
          </a>
        </li>
      </ul>
    </section>
  );
}
